import React, { useEffect, useMemo, useState } from 'react';
import ProgressChatPanel from '../../components/ProgressChatPanel';
import { fetchParentStudents } from '../../services/api';

const SCHOOL_BRAND_BY_NAME = {
	'Stellar Starlight School': {
		logo: '/69e03c5f0ce260dc5b607ea2_Stellar%20Starlight%20Main%20Logo%20-%20Color.png',
	},
	'CALE School': {
		logo: '/cale-logo.png',
	},
};

const ParentConnect = () => {
	const [students, setStudents] = useState<any>([]);

	useEffect(() => {
		let mounted = true;
		fetchParentStudents()
			.then((data) => {
				if (mounted) setStudents(data.students || []);
			})
			.catch(() => {
				if (mounted) setStudents([]);
			});

		return () => {
			mounted = false;
		};
	}, []);

	const enrolledSchools = useMemo(() => {
		const byKey = new Map();

		students.forEach((student) => {
			const classes = Array.isArray(student.classes) ? student.classes : [];

			classes.forEach((cls) => {
				const schoolId = cls?.school_id;
				const schoolName = cls?.school_name || '';
				const key = schoolId != null ? `id:${schoolId}` : `name:${schoolName.toLowerCase()}`;
				if (!schoolName || byKey.has(key)) return;

				const themed = SCHOOL_BRAND_BY_NAME[schoolName] || {};
				byKey.set(key, {
					name: schoolName,
					logo: themed.logo || '/academic-eye-logo.png',
				});
			});

			if (classes.length === 0 && student?.school_name) {
				const schoolName = student.school_name;
				const schoolId = student.school_id;
				const key = schoolId != null ? `id:${schoolId}` : `name:${schoolName.toLowerCase()}`;
				if (byKey.has(key)) return;

				const themed = SCHOOL_BRAND_BY_NAME[schoolName] || {};
				byKey.set(key, {
					name: schoolName,
					logo: themed.logo || '/academic-eye-logo.png',
				});
			}
		});

		return Array.from(byKey.values());
	}, [students]);

	return (
	<div style={{ display: 'grid', gap: 16 }}>
		<section style={{ background: '#ffffff', border: '1px solid #dbe4f0', borderRadius: 18, padding: 18, boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)' }}>
			<h1 style={{ fontSize: 28, fontWeight: 800, color: '#1e3a5f', marginBottom: 10 }}>Messages</h1>
			<p style={{ fontSize: 14, color: '#64748b', marginBottom: 16 }}>
				Stay informed, ask questions, and message teachers directly from the family Connect area.
			</p>
			<div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
				{enrolledSchools.length === 0 ? (
					<div style={{ background: '#f8fafc', border: '1px dashed #bed1ef', borderRadius: 12, padding: '8px 14px', fontSize: 12, color: '#64748b' }}>
						No enrolled school found yet for linked students.
					</div>
				) : enrolledSchools.map((brand) => (
					<div key={brand.name} style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#EEF7FF', border: '1px solid #BED1EF', borderRadius: 999, padding: '8px 14px' }}>
						<div style={{ width: 34, height: 34, borderRadius: 10, background: '#40669D', border: '1px solid #dbe4f0', overflow: 'hidden', flex: '0 0 auto' }}>
							<img src={brand.logo} alt={brand.name} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 'inherit', display: 'block' }} />
						</div>
						<span style={{ fontSize: 12, fontWeight: 700, color: '#1e3a5f' }}>{brand.name}</span>
					</div>
				))}
			</div>
			<div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 }}>
				{[
					{ title: 'Messages', desc: 'Open direct communication with teachers.' },
					{ title: 'Communication Hub', desc: 'Review recent and upcoming school updates.' },
					{ title: 'Calendar', desc: 'Track upcoming family and school activities.' },
				].map((card) => (
					<div key={card.title} style={{ borderRadius: 14, background: '#EEF7FF', border: '1px solid #BED1EF', padding: 14 }}>
						<div style={{ fontSize: 15, fontWeight: 800, color: '#1e3a5f', marginBottom: 8 }}>{card.title}</div>
						<div style={{ fontSize: 13, color: '#475569', lineHeight: 1.6 }}>{card.desc}</div>
					</div>
				))}
			</div>
		</section>
		<ProgressChatPanel roleLabel="Family" />
	</div>
);
};

export default ParentConnect;
